// @mui
import {
  Card,
  Stack,
} from '@mui/material';
// components
import Scrollbar from '../../components/Scrollbar';
// sections
import {
  TodoList,
  DoneList,
} from '.';


export default function TodoDoneCard({ crewId, todos, dones, isActive, isValidating }) {
  return (
    <Stack spacing={2}>
      <Card>
        <TodoList crewId={crewId} todos={todos} isActive={isActive} isValidating={isValidating} />
      </Card>
      <Card>
        <DoneList crewId={crewId} dones={dones} isActive={isActive} isValidating={isValidating} />
      </Card>
    </Stack>
  )

}
